module.exports = __webpack_public_path__ + "static/media/Читоркин Е. (СТО).8c64420d.pdf";